import ticker from '@/lib/ticker'
import { isSameFrame } from '@/lib/functions'
import videoAnalyzer from './videoAnalyzer'

// tslint:disable-next-line
const GIF = require('gif.js')
// tslint:disable-next-line
const workerScript = require('gif.js/dist/gif.worker')

interface IOptions {
  fps?: number
  width?: number
  onProcess?: (process: string) => void
}
interface ICommonConvertor {
  debug: boolean
  isCompatible: boolean
  resultWidth?: number
  resultHeight?: number
  start: (options: IOptions) => Promise<File>
}

const gifConvertor: ICommonConvertor = {
  debug: true,
  isCompatible: true,
  resultWidth: 0,
  resultHeight: 0,
  start: (
    { fps = 12, width = 100, onProcess = (process: string) => process } = {
      fps: 12,
      width: 100,
      onProcess: (process: string) => process,
    },
  ) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    const video = videoAnalyzer.video as HTMLVideoElement

    const resultWidth = Math.min(width, video.videoWidth)
    const resultWidthRatio = resultWidth / video.videoWidth
    const resultHeight = resultWidthRatio * video.videoHeight

    gifConvertor.resultWidth = resultWidth
    gifConvertor.resultHeight = resultHeight

    canvas.width = resultWidth
    canvas.height = resultHeight
    canvas.style.display = 'none'
    document.body.appendChild(canvas)

    const gif = new GIF({ width: resultWidth, height: resultHeight, workers: 4, workerScript, quality: 10 })

    return new Promise((resolve, reject) => {
      let lastTime = video.currentTime
      let lastPixels: null | ImageData = null

      const capture = () => {
        ctx.drawImage(video, 0, 0, resultWidth, resultHeight)
        const pixels = ctx.getImageData(0, 0, resultWidth, resultHeight)
        const duration = video.currentTime - lastTime
        onProcess(`Reading Video ${(video.currentTime / video.duration) * 100 || 0}%..`)

        if (!lastPixels || !isSameFrame(lastPixels, pixels)) {
          lastPixels = pixels
          lastTime = video.currentTime
          gif.addFrame(canvas, {
            copy: true,
            delay: duration * 1000,
          })
        }
        if (!video.ended) {
          ticker.start(capture, { fps })
        } else {
          ticker.pause()
          gif.render()
        }
      }

      requestAnimationFrame(capture)

      gif.on('finished', (blob: Blob) => {
        document.body.removeChild(canvas)
        resolve(new File([blob], `${videoAnalyzer.fileName}.gif`, {
          type: blob.type,
        }))
      })

      gif.on('progress', (p: number) => {
        onProcess(`Converting ${p * 100 || 0}%..`)
      })

      video.play()
      video.onerror = reject
    })
  },
}
const detect = () => {
  if (typeof Worker !== 'undefined') {
    gifConvertor.isCompatible = true
  } else {
    gifConvertor.isCompatible = false
  }
}

detect()

export default gifConvertor
